import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { useMapContext } from '../../contexts/MapContext';

const MapInitializer = () => {
    const { setMap } = useMapContext();
    const map = useMap();

    useEffect(() => {
        if (map) {
            setMap(map);
        }
    }, [map, setMap]);

    return null;
};

export default MapInitializer;
